export const SET_TEXT_CONNECTION_CALL = "SET_TEXT_CONNECTION_CALL";
export const SET_TEXT_SEQUENCE = "SET_TEXT_SEQUENCE";
